export default "__VITE_ASSET__f18afdc8__"